/**
 * admin.mahi.fashion — axios client.
 *
 * Own token key (`admin_mahi_token`), own base path (`/api/admin`) — this is
 * a separate service with a separate JWT, same reasoning as MAHI's own
 * `frontend/src/mira/api.js`: never let a consumer session and a staff
 * session be confusable with one another.
 */
import axios from 'axios';

const API_BASE = process.env.REACT_APP_ADMIN_BACKEND_URL;

const adminApi = axios.create({
  baseURL: `${API_BASE}/api/admin`,
  timeout: 20000,
});

adminApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem('admin_mahi_token');
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem('admin_mahi_token');
      if (typeof window !== 'undefined' && window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export default adminApi;

/** Coerce any backend error payload into a single user-readable string. */
export const errMsg = (e, fallback = 'Something went wrong') => {
  const d = e?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d) && d.length) return d.map((x) => x?.msg || x?.message || 'Invalid input').join(' · ');
  if (d && typeof d === 'object') return d.msg || d.message || fallback;
  return e?.message || fallback;
};
